export class Paths {
  static Home = "/";
  static Parent = "/parent";
  static Teacher = "/teacher";
  static TeacherClassSetup = "/class-setup/teacher";
  static ParentClassSetup = "/class-setup/parent";
}
